import React from "react";
import { FiVideo, FiMail, FiUsers, FiCalendar, FiClock } from "react-icons/fi";

import { GiBrain } from "react-icons/gi";

export default [
  {
    icon: <FiVideo />,
    label: "Telemedicina",
    route: "/home",
    product: "TELEMEDICINA",
  },
  {
    icon: <GiBrain />,
    product: "TELEPSICOLOGIA",
    label: "Telepsicologia",
    route: "/telepsicologia",
    needEgilibility: true,
    needEligibilityTelepsicologia: true,
  },
  {
    icon: <FiCalendar />,
    label: "Agenda",
    route: "/consultas-agendadas",
    needEgilibility: true,
    needScheduling: true,
    product: "ANY",
  },
  {
    icon: <FiUsers />,
    label: "Médicos Einstein",
    route: "/especialistas-corporate",
    needEgilibility: true,
    product: "CORPORATE",
  },
  {
    icon: <FiClock />,
    label: "Histórico",
    route: "/historico",
    needEgilibility: false,
  },
  {
    icon: <FiUsers />,
    label: "Dependentes",
    route: "/dependentes",
  },
  {
    icon: <FiMail />,
    label: "Contato",
    route: "/fale-conosco",
  },
];
